import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Button, Input, InputNumber, DatePicker, message } from 'antd';
import _ from 'lodash';
import moment from 'moment';
import { graphql } from 'react-apollo';
import validationRegex from '../../utils/validationRegex';

import MUTATION from '../../graphql/mutations/editCustomerAssociateConcernMutation.graphql';
import STORE_QUERY from '../../graphql/queries/getCustomerAssociateConcernsQuery.graphql';

const { Column, ColumnGroup } = Table;

class AssociateConcernDebt extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submittingForm: false,
      debtPosition: props.debtPosition.map(({ __typename, ...entry }) => (entry)),
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.debtPosition, nextProps.debtPosition)) {
      this.setState({
        debtPosition: _.unionBy(nextProps.debtPosition.map(({ __typename, ...entry }) => (entry)), this.state.debtPosition, 'id'),
      });
    }
  }

  addNewRow = () => {
    const newDebtPosition = [...this.state.debtPosition];
    newDebtPosition.push({
      id: (+new Date()).toString(36),
      bank_name: '',
      sanction_bg_lc: 0,
      sanction_tl: 0,
      sanction_cc: 0,
      oa_date: moment().format('YYYY-MM-DD'),
      oa_bg_lc: 0,
      oa_tl: 0,
      oa_cc: 0,
      oa_roi: 0,
      oa_asset_classification: '',
    });
    this.setState({ debtPosition: newDebtPosition });
  };

  removeLastRow = () => {
    this.setState({
      debtPosition: this.state.debtPosition.slice(-1),
    });
  };

  handleValueChange = (value, id, key) => {
    this.setState({
      debtPosition: this.state.debtPosition.map((entry) => {
        const newEntry = entry;
        if (entry.id === id) entry[key] = value;
        return newEntry;
      }),
    });
  };

  handleSubmit = () => {
    this.setState({
      submittingForm: true,
    });
    const { debtPosition } = this.state;
    let formHasErrors = false;
    if (debtPosition.length < 1) formHasErrors = true;
    debtPosition.forEach((entry) => {
      if (!validationRegex.stringWithSpecialChars.test(entry.bank_name)) formHasErrors = true;
      if (!validationRegex.float.test(entry.sanction_bg_lc) || entry.sanction_bg_lc <= 0) formHasErrors = true;
      if (!validationRegex.float.test(entry.sanction_tl) || entry.sanction_tl <= 0) formHasErrors = true;
      if (!validationRegex.float.test(entry.sanction_cc) || entry.sanction_cc <= 0) formHasErrors = true;
      if (!validationRegex.dateString.test(entry.oa_date)) formHasErrors = true;
      if (!validationRegex.float.test(entry.oa_bg_lc) || entry.oa_bg_lc <= 0) formHasErrors = true;
      if (!validationRegex.float.test(entry.oa_tl) || entry.oa_tl <= 0) formHasErrors = true;
      if (!validationRegex.float.test(entry.oa_cc) || entry.oa_cc <= 0) formHasErrors = true;
      if (!validationRegex.float.test(entry.oa_roi) || entry.oa_roi <= 0) formHasErrors = true;
      if (!validationRegex.stringWithSpecialChars.test(entry.oa_asset_classification)) formHasErrors = true;
    });

    if (formHasErrors) {
      this.setState({
        submittingForm: false,
      });
      message.error('Enter all values correctly before submitting!');
    } else {
      const { customer_id, cac_id } = this.props;
      const { debtPosition: debt_position } = this.state;

      this.props.mutate({
        variables: {
          id: cac_id,
          debt_position,
        },
        // update: (cache, { data: { cac } }) => {
        //   const data = cache.readQuery({
        //     query: STORE_QUERY,
        //     variables: { customer_id },
        //   });
        //   data.associateConcerns = data.associateConcerns.map((ac) => {
        //     const entry = ac;
        //     if (entry.id === parseInt(cac_id, 10)) {
        //       // entry.debt_position = debt_position.map((entry1) => ({ ...entry1, __typename: 'AssociateConcernDebt' }));
        //       entry.debt_position = cac.debt_position;
        //     }
        //     return entry;
        //   });
        //   cache.writeQuery({ query: STORE_QUERY, variables: { customer_id }, data });
        // },
      })
        .then(() => {
          this.setState({
            submittingForm: false,
          });
          message.success('Success!');
        })
        .catch((mutateErr) => {
          console.log(mutateErr);
          this.setState({
            submittingForm: false,
          });
          message.error(mutateErr.message);
        });
    }
  };

  render() {
    let total = 0;
    this.state.debtPosition.forEach((entry) => {
      total += entry.sanction_bg_lc + entry.sanction_tl + entry.sanction_cc;
    });

    return (
      <div>
        <Button onClick={this.addNewRow}>Add new Bank</Button>
        <Button onClick={this.removeLastRow}>Remove last row</Button>
        <Table dataSource={this.state.debtPosition} bordered rowKey="id" pagination={false} scroll={{ x: 1800 }}>
          <Column
            title="Name of Bank"
            key="bank_name"
            render={(text, record) => (
              <Input value={record.bank_name} onChange={(e) => { this.handleValueChange(e.target.value, record.id, 'bank_name'); }} />
            )}
          />
          <ColumnGroup title="Sanction Amount">
            <Column
              title="BG/LC"
              key="sanction_bg_lc"
              render={(text, record) => (
                <InputNumber size="small" value={record.sanction_bg_lc} onChange={(value) => { this.handleValueChange(value, record.id, 'sanction_bg_lc'); }} style={{ width: 70 }} />
              )}
            />
            <Column
              title="TL"
              key="sanction_tl"
              render={(text, record) => (
                <InputNumber size="small" value={record.sanction_tl} onChange={(value) => { this.handleValueChange(value, record.id, 'sanction_tl'); }} style={{ width: 70 }} />
              )}
            />
            <Column
              title="CC"
              key="sanction_cc"
              render={(text, record) => (
                <InputNumber size="small" value={record.sanction_cc} onChange={(value) => { this.handleValueChange(value, record.id, 'sanction_cc'); }} style={{ width: 70 }} />
              )}
            />
            <Column
              title="Total"
              key="sanction_total"
              render={(text, record) => (record.sanction_bg_lc + record.sanction_tl + record.sanction_cc)}
            />
          </ColumnGroup>
          <Column
            title="Share"
            key="share"
            render={(text, record) => ((((record.sanction_bg_lc + record.sanction_tl + record.sanction_cc) / total) * 100).toFixed(2))}
          />
          <ColumnGroup title="Outstanding Amount">
            <Column
              title="Date"
              key="oa_date"
              render={(text, record) => (
                <DatePicker
                  style={{ width: 120 }}
                  size="small"
                  defaultValue={moment(record.oa_date)}
                  onChange={(date, dateString) => { this.handleValueChange(dateString, record.id, 'oa_date'); }}
                />
              )}
            />
            <Column
              title="BG/LC"
              key="oa_bg_lc"
              render={(text, record) => (
                <InputNumber size="small" value={record.oa_bg_lc} onChange={(value) => { this.handleValueChange(value, record.id, 'oa_bg_lc'); }} style={{ width: 70 }} />
              )}
            />
            <Column
              title="TL"
              key="oa_tl"
              render={(text, record) => (
                <InputNumber size="small" value={record.oa_tl} onChange={(value) => { this.handleValueChange(value, record.id, 'oa_tl'); }} style={{ width: 70 }} />
              )}
            />
            <Column
              title="CC"
              key="oa_cc"
              render={(text, record) => (
                <InputNumber size="small" value={record.oa_cc} onChange={(value) => { this.handleValueChange(value, record.id, 'oa_cc'); }} style={{ width: 70 }} />
              )}
            />
            <Column
              title="Total"
              key="oa_total"
              render={(text, record) => (record.oa_bg_lc + record.oa_tl + record.oa_cc)}
            />
            <Column
              title="ROI"
              key="oa_roi"
              render={(text, record) => (
                <InputNumber size="small" value={record.oa_roi} onChange={(value) => { this.handleValueChange(value, record.id, 'oa_roi'); }} style={{ width: 60 }} />
              )}
            />
            <Column
              title="Asset Classification"
              key="oa_asset_classification"
              render={(text, record) => (
                <Input value={record.oa_asset_classification} onChange={(e) => { this.handleValueChange(e.target.value, record.id, 'oa_asset_classification'); }} />
              )}
            />
          </ColumnGroup>
        </Table>
        <br />
        <Button onClick={this.handleSubmit} loading={this.state.submittingForm} type="primary">Save</Button>
      </div>
    );
  }
}

AssociateConcernDebt.propTypes = {
  debtPosition: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
  })).isRequired,
  cac_id: PropTypes.string.isRequired,
  customer_id: PropTypes.string.isRequired,
  mutate: PropTypes.func.isRequired,
};

export default graphql(MUTATION)(AssociateConcernDebt);



// WEBPACK FOOTER //
// ./src/pages/factsheet/AssociateConcernDebt.jsx